$(function() {
  var tenderPage = $('.tenders-controller-index');


  if (tenderPage.length > 0) {
    var tenderForm = $('.tender-search-form');
    var tenderResults = $('.tender-search__results');
    var tenderRegionSelect = $('.tenders__region-select');

    tenderForm.on('ajax:success', function(event) {
      const data = event.detail[2].responseText;
      tenderResults.html(data);
    }).on('ajax:error', function(event) {
      // alert('error');
    });

    tenderRegionSelect.on('change', function(event) {
      Rails.fire(tenderForm[0], 'submit');
    });
  }

  var tenderDetailPage = $('.tenders-controller-show, .tenders-controller-apply');
  if (tenderDetailPage.length > 0) {
    $('.tender-hero__apply_btn').on('click', function(event) {
      event.preventDefault();
      $('.tender-form__container').slideToggle(400, function() {
        ga('send', 'event', 'Tender Apply Form', ($(this).is(':visible') ? 'open' : 'close'));
      });
      selectize_all_selects();
    });

    var button_selector = '#forms_tender_apply_form_attachment';
    var target_selector = '.contact_form-attachments';
    $(button_selector).on('change', function() {
      $(target_selector).html('');
      for (index = 0; index < this.files.length; ++index) {
        $(target_selector).append('<div class="upload-file-entry">' + this.files[index].name + '<a href="#"><span class="fa fa-remove remove-upload-file"></span></a></div>');
      }
      removeFileHandler(this, target_selector);
    });

    function removeFileHandler(uploadField, target_selector) {
      $(target_selector + ' .remove-upload-file').on('click', function(event) {
        $(uploadField).val("");
        $(target_selector).html("");
        event.preventDefault();
      });
    }
  }
});
